export default __webpack_public_path__ + "static/media/trash.19253773.svg";